module.exports = __webpack_public_path__ + "img/pic22.8849bebe.png";